import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as ArchiveIcon } from 'assets/icons/archive-primary.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { ArchiveMultiOwnersProps } from './ArchiveMultiOwners.types';

export const ArchiveMultiOwners = ({
  checkedOwners,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: ArchiveMultiOwnersProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const canEditOwner = perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <Tooltip title={formatMessage({ id: AppMessages['common.noPermissions'] })} disableHoverListener={canEditOwner}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<ArchiveIcon />}
          onClick={onModalOpen}
          disabled={!canEditOwner}
        >
          {formatMessage({ id: AppMessages['owners.multiAction.archive.title'] })}
        </Button>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['owners.multiAction.archive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['owners.multiAction.archive.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['owners.multiAction.archive.subtitle'] })} {checkedOwners.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['owners.multiAction.archive.confirm'] })}</ActionModal.Text>

        <br />

        <ActionModal.Text>
          {formatMessage({ id: AppMessages['owners.multiAction.archive.description'] })}
        </ActionModal.Text>
      </ActionModal>
    </>
  );
};
